import { UserSettings, UserSettingsKey } from '@/pages/Appbar';
import { Link } from '@/utils/links';
import {
  Box,
  Divider,
  IconButton,
  TextField as MUITextField,
  Popover,
  Stack,
} from '@mui/material';
import { useEffect, useState } from 'react';
import Checkbox from './Checkbox';
import SettingsIcon from './icons/SettingsIcon';

type Props = {
  toggleCheckbox: (key: UserSettingsKey) => void;
  handleChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    name: UserSettingsKey
  ) => void;
  userSettings: UserSettings;
  toggleLink: (path: string) => void;
  links: Link[];
};

const SettingsModal = ({
  toggleCheckbox,
  userSettings,
  handleChange,
  toggleLink,
  links,
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  useEffect(() => {
    if (userSettings.darkMode) {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }, [userSettings.darkMode]);

  return (
    <>
      <IconButton onClick={handleClick}>
        <SettingsIcon />
      </IconButton>

      <Popover
        id="settings-modal"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            sx: {
              background: userSettings.darkMode ? '#1f2023' : 'white',
              color: userSettings.darkMode ? 'white' : 'black',
            },
          },
        }}
      >
        <Box
          sx={{
            margin: 2,
            width: 300,
            height: 300,
          }}
        >
          <h3>Settings</h3>
          <Divider />
          <Stack gap={0.5}>
            <Checkbox
              id={`settings-showDateRangePicker`}
              onChange={() => toggleCheckbox('showDateRangePicker')}
              checked={userSettings.showDateRangePicker}
            >
              Show date range picker 🗓️
            </Checkbox>
            <Checkbox
              id={`settings-darkMode`}
              onChange={() => toggleCheckbox('darkMode')}
              checked={userSettings.darkMode}
            >
              Dark mode {userSettings.darkMode ? '🌑' : '☀️'}
            </Checkbox>
            <Checkbox
              id={`settings-isMobile`}
              onChange={() => toggleCheckbox('isMobile')}
              checked={userSettings.isMobile}
            >
              Mobile 📱
            </Checkbox>
            <MUITextField
              type="number"
              size="small"
              label="FTP (W)"
              value={userSettings.FTP}
              onChange={(event) => handleChange(event, 'FTP')}
              sx={{ my: 1, width: '150px' }}
            />
            <MUITextField
              type="number"
              size="small"
              label="Weight (kg)"
              value={userSettings.weight}
              onChange={(event) => handleChange(event, 'weight')}
              sx={{ width: '150px' }}
            />
            <h3 style={{ marginTop: '20px' }}>Menus</h3>
            <Divider />
            {links.map((link) => (
              <Checkbox
                id={link.path}
                key={link.path}
                checked={link.show}
                onChange={() => toggleLink(link.path)}
              >
                {link.name}
                {link.experimental ? ' ⚠️ ' : ''}
              </Checkbox>
            ))}
          </Stack>
        </Box>
      </Popover>
    </>
  );
};

export default SettingsModal;
